import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["input", "list"]
  static values = {
    url: String,
    maxSize: Number,
    allowedTypes: Array
  }

  connect() {
    // Drag & Drop events
    this.element.addEventListener("dragover", (e) => {
      e.preventDefault()
      this.element.classList.add("bg-emerald-50", "border-emerald-500")
      this.element.classList.remove("border-gray-300")
    })
    this.element.addEventListener("dragleave", (e) => {
      e.preventDefault()
      this.element.classList.remove("bg-emerald-50", "border-emerald-500")
      this.element.classList.add("border-gray-300")
    })
    this.element.addEventListener("drop", (e) => {
      e.preventDefault()
      this.element.classList.remove("bg-emerald-50", "border-emerald-500")
      this.element.classList.add("border-gray-300")
      this.handleFiles({ target: { files: e.dataTransfer.files } })
    })

    // Click to open file picker
    this.element.addEventListener("click", () => this.inputTarget.click())
  }

  handleFiles(event) {
    const files = event.target.files
    Array.from(files).forEach((file) => this.uploadFile(file))
  }

  validateFile(file, wrapper) {
    var errors = []

    // Vérification taille
    if (file.size > this.maxSizeValue) {
      errors.push('Le fichier dépasse la taille maximale autorisée')
    }

    // Vérification type MIME
    if (!this.allowedTypesValue.includes(file.type)) {
      errors.push('Type de fichier non autorisé')
    }

    if (errors.length > 0) {
      const error = document.createElement("div")
      error.className = "text-sm text-left text-red-700 font-medium"
      error.textContent = errors.join(', ')
      wrapper.appendChild(error)
      setTimeout(() => {
        wrapper.remove()
      }, 5000);
      return false
    }

    return true
  }

  uploadFile(file) {
    // Conteneur global pour chaque fichier
    const wrapper = document.createElement("div")
    wrapper.className = "mt-4"

    // Nom du fichier
    const filename = document.createElement("div")
    filename.className = "text-sm text-gray-700 font-bold"
    filename.textContent = file.name

    const percent = document.createElement("div")
    percent.className = "text-sm text-gray-700 font-bold"
    percent.textContent = "0%"

    const details = document.createElement("div")
    details.className = "w-full flex justify-between"
    details.appendChild(filename)
    details.appendChild(percent)
    wrapper.appendChild(details)

    // Barre de progression
    const container = document.createElement("div")
    container.className = "w-full bg-gray-200 rounded-full h-2"

    const bar = document.createElement("div")
    bar.className = "bg-blue-500 h-2 rounded-full transition-all duration-300 ease-in-out"
    bar.style.width = "0%"
    container.appendChild(bar)

    wrapper.appendChild(container)
    this.listTarget.appendChild(wrapper)

    if (!this.validateFile(file, wrapper)) return

    const formData = new FormData()
    formData.append("file", file)

    const xhr = new XMLHttpRequest()
    xhr.open("POST", this.urlValue, true)

    const token = document.querySelector('meta[name="csrf-token"]').content
    xhr.setRequestHeader("X-CSRF-Token", token)
    xhr.setRequestHeader("Accept", "text/vnd.turbo-stream.html, text/html")

    xhr.upload.addEventListener("progress", (e) => {
      if (e.lengthComputable) {
        const value = Math.round((e.loaded / e.total) * 100)
        bar.style.width = `${value}%`
        percent.textContent = `${value}%`
      }
    })

    xhr.onload = () => {
      if (xhr.status === 200) {
        bar.classList.add("bg-emerald-500")
        const success = document.createElement("div")
        success.className = "text-sm text-left text-emerald-500 font-medium"
        success.textContent = (xhr.status === 422 ? xhr.responseText : "Fichier ajouté avec succès")
        wrapper.appendChild(success)
        // Applique la réponse avec Turbo
        Turbo.renderStreamMessage(xhr.responseText)
      } else {
        bar.classList.add("bg-red-500")
        const error = document.createElement("div")
        error.className = "text-sm text-left text-red-700 font-medium"
        error.textContent = (xhr.status === 422 ? xhr.responseText : "Une erreur est survenue")
        wrapper.appendChild(error)
      }

      setTimeout(() => {
        wrapper.remove()
      }, 5000); // 1000 = 1 seconde
    }

    xhr.send(formData)
  }
}